import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	congrats: {
		id: 'partner.success.congrats',
		defaultMessage: 'Congratulations!',
		description: 'Success congrats',
	},
	successText: {
		id: 'partner.success.downloadApp',
		defaultMessage:
			"You have access to <bold>Calm Premium!</bold>{breakingLine}We recommend downloading the Calm app and starting your journey there.{breakingLine}After downloading the app, {login} to unlock the premium content.{breakingLine}You'll find a comprehensive library of content from Meditations, Sleep Stories, and Music. All to help you manage stress, mental health, and so much more.{breakingLine}",
		description: 'Success body text',
	},
	successTextFacebook: {
		id: 'partner.success.useFbLogin',
		defaultMessage: 'choose Log in with Facebook',
		description: 'Indicates the user should login with Facebook',
	},
	successTextEmail: {
		id: 'partner.success.useEmailLogin',
		defaultMessage: 'log in with your email address {customerEmail}',
		description: 'Indicates the user should login with their provided email',
	},
	pathwaysWelcomeHeader: {
		id: 'partner.pathwaysSuccess.welcome.full',
		defaultMessage: 'Welcome to {Calm}',
		description: 'Welcome message shown next to the Calm inline logo',
	},
	pathwaysComingUp: {
		id: 'partner.pathwaysSuccess.comingUp',
		defaultMessage: 'Your Pathway is coming up',
		description: 'Subheading copy',
	},
	pathwaysDownloadCopyShort: {
		id: 'partner.pathwaysSuccess.downloadCopyShort',
		defaultMessage: 'Download the app and enable notifications to receive step-by-step updates.',
		description: 'Download and notification instruction copy.',
	},
	pathwaysDownloadCopy: {
		id: 'partner.pathwaysSuccess.downloadCopy',
		defaultMessage:
			"Download the app to get started, and don't forget to enable notifications to be notified each step of the way.",
		description: 'Download and notification instruction copy.',
	},
	pathwaysDownloadCta: {
		id: 'partner.pathwaysSuccess.download.cta',
		defaultMessage: 'Download app',
		description: 'Download app cta button copy.',
	},
	pathwaysMaybeLaterCta: {
		id: 'partner.pathwaysSuccess.maybeLater.cta',
		defaultMessage: 'Maybe later',
		description: 'Maybe later cta button copy, rather than downloading the app.',
	},
	pathwaysQrCodeCopy: {
		id: 'partner.pathwaysSuccess.qrCode',
		defaultMessage: 'Scan this QR code to download Calm',
		description: 'Instructions for scanning the qr code to download the app.',
	},
	successTitle: {
		id: 'partner.success.title',
		defaultMessage: 'Your Calm account is now active!',
		description: 'Title shown to the user when their subscription has been successfully redeemed',
	},
	successParagraph: {
		id: 'partner.success.successParagraph',
		defaultMessage:
			"Download the Calm app to your mobile device and {login} in order to unlock all of Calm's great content.",
		description: 'Paragraph shown to the user when their subscription has been successfully redeemed',
	},
	successLoginWithEmail: {
		id: 'partner.success.successLoginWithEmail',
		defaultMessage: 'log in with the same <bold>email address</bold> you used to activate your account',
		description: 'Text shown if the auth method is email or undefined',
	},
	successLoginWithThirdPartyApp: {
		id: 'partner.success.successLoginWithThirdPartyApp',
		defaultMessage: '<bold>log in with {thirdPartyApp}</bold>',
		description: 'Text shown if the auth method is a third party app',
	},
	successButton: {
		id: 'partner.success.successButton',
		defaultMessage: 'Open Calm App',
		description: 'Text shown on the button in the success widget.',
	},
});
